// extracted by mini-css-extract-plugin
export var buttons = "_9w-0";
export var buttonsActive = "_9w-h";
export var cancelConfirm = "_9w-1";
export var closeButton = "_9w-2";
export var column = "_9w-3";
export var container = "_9w-4";
export var detailHeader = "_9w-6";
export var detailTitle = "_9w-7";
export var detailsContent = "_9w-5";
export var header = "_9w-8";
export var headerWithClose = "_9w-9";
export var icon = "_9w-a";
export var infoIcon = "_9w-c";
export var informationContainer = "_9w-b";
export var sideDrawer = "_9w-d";
export var sideDrawerOpen = "_9w-e";
export var stickyFooter = "_9w-f";
export var typeOption = "_9w-g";